import qs from 'qs';
import axios from '@/api/axios';

const TARGETS_URL = '/targets';

export default {
  index(params) {
    return axios.get(TARGETS_URL, {
      params: params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
    });
  },
  show(id) {
    return axios.get(`${TARGETS_URL}/${id}`);
  },
  create(data) {
    return axios.post(TARGETS_URL, data);
  },
  update(id, data) {
    return axios.patch(`${TARGETS_URL}/${id}`, data);
  },
  delete(id) {
    return axios.delete(`${TARGETS_URL}/${id}`);
  },
};
